module.exports = __webpack_public_path__ + "/login_ui/img/help-b2c9ae7732f15e476b4f4f246ccb7438.svg";